<nav
  class="flex flex-col gap-6 border border-outline dark:border-outline-darkmode rounded-md w-full pt-5 pb-6 px-6"
>
  <div class="flex gap-2 items-center">
    <h2 class="flex-1 leading-6 line-clamp-1 font-semibold text-base">
      {{ 'cockpit.parseRequests.createNav.title' | transloco }}
    </h2>
    <!-- info button -->
    <a
      [href]="sidebarNavInfoButtonLink()"
      target="_blank"
      [title]="'cockpit.parseRequests.createNav.infoButtonTitle' | transloco"
      class="flex-none"
      *appFeatureEnabled="'helpCenter'"
    >
      <ui-button [iconOnly]="true" mode="outlined" size="small">
        <ng-icon name="heroInformationCircle" size="20" class="!block" />
      </ui-button>
    </a>
  </div>
  <ul class="flex flex-col gap-6 text-sm">
    <li
      class="flex gap-3 items-center leading-5 line-clamp-2"
      [ngClass]="
        documents.isActive
          ? 'text-on-surface dark:text-on-surface-darkmode font-semibold'
          : 'text-on-surface-variant dark:text-on-surface-variant-darkmode'
      "
    >
      <div class="flex-none">
        @if (parseRequest()?.state?.documentUpload; as state) {
          <app-parse-request-state-icon [state]="state" />
        }
      </div>
      <div
        routerLink="documents"
        routerLinkActive
        #documents="routerLinkActive"
        class="flex-1 pointer-events-none"
      >
        {{ 'cockpit.parseRequests.createNav.uploadDocuments' | transloco }}
      </div>
    </li>
    <li
      class="flex gap-3 items-center leading-5 line-clamp-2"
      [ngClass]="
        general.isActive
          ? 'text-on-surface dark:text-on-surface-darkmode font-semibold'
          : 'text-on-surface-variant dark:text-on-surface-variant-darkmode'
      "
    >
      <div class="flex-none">
        @if (parseRequest()?.state?.generalInformation; as state) {
          <app-parse-request-state-icon [state]="state" />
        }
      </div>
      <div
        routerLink="general"
        routerLinkActive
        #general="routerLinkActive"
        class="flex-1 pointer-events-none"
      >
        {{ 'cockpit.parseRequests.createNav.generalInformation' | transloco }}
      </div>
    </li>
    <li
      class="flex gap-3 items-center leading-5 line-clamp-2"
      [ngClass]="
        summary.isActive
          ? 'text-on-surface dark:text-on-surface-darkmode font-semibold'
          : 'text-on-surface-variant dark:text-on-surface-variant-darkmode'
      "
    >
      <div class="flex-none">
        @if (parseRequest()?.state?.summary; as state) {
          <app-parse-request-state-icon [state]="state" />
        }
      </div>
      <div
        routerLink="summary"
        routerLinkActive
        #summary="routerLinkActive"
        class="flex-1 pointer-events-none"
      >
        {{ 'cockpit.parseRequests.createNav.summary' | transloco }}
      </div>
    </li>
  </ul>
</nav>
